import { ENUM_COLORS } from '@commons/Text';

export const calculateChange = (current, previous, isPercentage) =>
  (!current || isNaN(current) || current == 0) && (!previous || isNaN(previous) || previous == 0)
    ? null
    : isPercentage
    ? (Math.round(current * 100) - Math.round(previous * 100)) / 100
    : !previous || isNaN(previous) || previous == 0
    ? 100
    : Math.round(((current - previous) / previous) * 100 * 100) / 100;

export const calculateColor = (roundedChange, isIncreasePositive) =>
  roundedChange == 0 || !roundedChange
    ? ENUM_COLORS.DARKER
    : (roundedChange > 0 && isIncreasePositive) || (roundedChange < 0 && !isIncreasePositive)
    ? ENUM_COLORS.INFO_GREEN
    : ENUM_COLORS.INFO_RED;

export const METRIC_TYPE = {
  PERCENTAGE: 'percentage',
  CURRENCY: 'currency',
  CURRENCY_WITH_DECIMALS: 'currency_with_decimals',
  INTEGER: 'integer',
};

export const formatNumberForExport = (number) => (number ? Math.round(number * 100) / 100 : number);
